"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CompoundComponentContext = void 0;
exports.useCompoundParent = useCompoundParent;
var React = _interopRequireWildcard(require("react"));
var CompoundComponentContext = exports.CompoundComponentContext = /*#__PURE__*/ React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
    CompoundComponentContext.displayName = 'CompoundComponentContext';
}
/**
 * Sorts the subitems by their position in the DOM.
 */ function sortSubitems(subitems) {
    var subitemsArray = Array.from(subitems.keys()).map(function(key) {
        var subitem = subitems.get(key);
        return {
            key: key,
            subitem: subitem
        };
    });
    subitemsArray.sort(function(a, b) {
        var aNode = a.subitem.ref.current;
        var bNode = b.subitem.ref.current;
        if (aNode === null || bNode === null || aNode === bNode) {
            return 0;
        }
        // eslint-disable-next-line no-bitwise
        return aNode.compareDocumentPosition(bNode) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1;
    });
    return new Map(subitemsArray.map(function(item) {
        return [
            item.key,
            item.subitem
        ];
    }));
}
/**
 * Provides a way for a component to know about its children.
 *
 * Child components register themselves with the `useCompoundItem` hook, passing in arbitrary metadata to the parent.
 *
 * This is a more powerful altervantive to `children` traversal, as child components don't have to be placed
 * directly inside the parent component. They can be anywhere in the tree (and even rendered by other components).
 *
 * The downside is that this doesn't work with SSR as it relies on the useEffect hook.
 *
 * @ignore - internal hook.
 */ function useCompoundParent() {
    var _React_useState = _sliced_to_array(React.useState(new Map()), 2), subitems = _React_useState[0], setSubitems = _React_useState[1];
    var subitemKeys = React.useRef(new Set());
    var deregisterItem = React.useCallback(function deregisterItem(id) {
        subitemKeys.current.delete(id);
        setSubitems(function(previousState) {
            var newState = new Map(previousState);
            newState.delete(id);
            return newState;
        });
    }, []);
    var registerItem = React.useCallback(function registerItem(id, item) {
        var providedOrGeneratedId;
        if (typeof id === 'function') {
            providedOrGeneratedId = id(subitemKeys.current);
        } else {
            providedOrGeneratedId = id;
        }
        subitemKeys.current.add(providedOrGeneratedId);
        setSubitems(function(previousState) {
            var newState = new Map(previousState);
            newState.set(providedOrGeneratedId, item);
            return newState;
        });
        return {
            id: providedOrGeneratedId,
            deregister: function() {
                return deregisterItem(providedOrGeneratedId);
            }
        };
    }, [
        deregisterItem
    ]);
    var sortedSubitems = React.useMemo(function() {
        return sortSubitems(subitems);
    }, [
        subitems
    ]);
    var getItemIndex = React.useCallback(function getItemIndex(id) {
        return Array.from(sortedSubitems.keys()).indexOf(id);
    }, [
        sortedSubitems
    ]);
    var contextValue = React.useMemo(function() {
        return {
            getItemIndex: getItemIndex,
            registerItem: registerItem,
            totalSubitemCount: subitems.size
        };
    }, [
        getItemIndex,
        registerItem,
        subitems.size
    ]);
    return {
        contextValue: contextValue,
        subitems: sortedSubitems
    };
}
